import { render, staticRenderFns } from "./kpiDocs.vue?vue&type=template&id=4437a200&scoped=true"
import script from "./kpiDocs.vue?vue&type=script&lang=js"
export * from "./kpiDocs.vue?vue&type=script&lang=js"
import style0 from "./kpiDocs.vue?vue&type=style&index=0&id=4437a200&prod&lang=scss&scoped=true"
import style1 from "./kpiDocs.vue?vue&type=style&index=1&id=4437a200&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4437a200",
  null
  
)

export default component.exports